"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var load_themed_styles_1 = require("@microsoft/load-themed-styles");
load_themed_styles_1.loadStyles([{ "rawString": ".root_2084a428{display:block;position:relative}.measured_2084a428{position:fixed;visibility:hidden}\n" }]);
exports.root = "root_2084a428";
exports.measured = "measured_2084a428";
//# sourceMappingURL=ResizeGroup.scss.js.map


//////////////////
// WEBPACK FOOTER
// ../~/office-ui-fabric-react/lib/components/ResizeGroup/ResizeGroup.scss.js
// module id = ../node_modules/office-ui-fabric-react/lib/components/ResizeGroup/ResizeGroup.scss.js
// module chunks = 1